import { IEnvironment } from 'src/app/modules/shared/models/IEnvironment';

export const environment: IEnvironment = {
  environment: 'production',
  production: true,
  apiBase: 'https://api.glimpsecorp.com',
  jwtWhitelistedDomains: ['api.glimpsecorp.com', 'glimpseapi-linux.azurewebsites.net'],
  mixpanelToken: '58ed917755912b8568b5ddaa6e6c7fc5',
  sentryDsn: 'https://48b3df680c60421f967d82d77a86e42a@o565493.ingest.sentry.io/5707386',
  storageBase: 'https://videoauditing.blob.core.windows.net',
  pushVapidPublicKey: 'BOKaPAfwmvXdiA7rIPicBLX78hrH_86CJwVxI0Ryf7mb2G4vWHOFLEGJq4j30ZZrpeyHMwD6hDwSu-KRqVPZBWk',
  cloudDashboardUrl: 'https://glimpse.grafana.net/d/adtat60g7n85cc/cloud-processing?var-cameraId=',
};
